/**
 * Mock API for room-related operations
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let nextId = 1;
export const mockRoomApi = {
    getRoomByCode: (code) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve({ id: 1, code, name: 'Mock Room' }), 300));
    }),
    list: (createdById) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve([{ id: 1, code: 'mock', name: 'Mock Room' }]), 300));
    }),
    create: (data) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve(Object.assign(Object.assign({}, data), { id: nextId++ })), 300));
    }),
    update: (id, data) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve(Object.assign(Object.assign({}, data), { id })), 300));
    }),
    delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve({ id }), 300));
    }),
};
